import React, { useContext, useEffect, useState } from "react";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  INIT_ESB,
  SEND_OTP,
  VERIFY_OTP
} from "../../Config";
import BackButton from "../../assets/svg/EPL_think_svg/BackButton.svg";
import EditIcon from "../../assets/svg/EPL_think_svg/Icon_Edit.svg";
import LoanExpired from "../../assets/svg/EPL_think_svg/loan_expired.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import PrivacyPolicy from "../../components/advance/PrivacyPolicy";
import FloatingInput from "../../components/base/FloatingInput.js";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import jwt_decode from "jwt-decode";
import { isValidSearchParams } from "../../shared/validations/SearchParams.js";

import Title from "../../components/core/Title";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidMobileNumber } from "../../shared/validations/MobileNumber";
import { isValidOTP } from "../../shared/validations/OTP";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { LoginWrapper } from "./_styles/LoginWrapper";

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import CheckField from "../../components/form/CheckField.js";
import { createLead } from "../../shared/services/crm";
import {
  IncorrectOtpModal,
  InvalidCaptchaModal,
  InvalidHashModal,
  InvalidURLModal,
  MaxOtpRetryModal,
  MaxVerifyOtpRetryModal,
  NoOfferFoundModal,
  OtpExpiredModal,
  ResendOtpModal,
} from "../other-pages/Modals/AllModal";
import { encryptedData } from "../../utils/index.js";

const Login = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const inValidNumericEntries = ["e", "-"];
  const [mobNum, setMobNum] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [mobileNumberErrorMessage, setMobileNumberErrorMessage] = useState(
    "Please enter valid mobile number"
  );
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [isValidNum, setIsValidNum] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [otp, setOtp] = useState("");
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [resendOtp, setResendOtp] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);

  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [showVerifyMaxRetryModal, setShowVerifyMaxRetryModal] = useState(false);
  const [showNoOfferModal, setShowNoOfferModal] = useState(false);
  const [showInvalidHashModal, setShowInvalidHashModal] = useState(false);
  const [showInvalidURLModal, setShowInvalidURLModal] = useState(false);
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const source = location.pathname.split("/")[1]; // "epl"
  const [showInvalidCaptchaModal, setShowInvalidCaptchaModal] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
	const [urlParams, setUrlParams] = useState("");

  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [consentFlag, setConsentFlag] = useState(true);

  const updateConsentCheckbox = () => {
    setConsentCheckbox(!consentCheckbox);
  };

   useEffect( async () => {
		if (isValidSearchParams() && searchParams.get("dsa_hash")) {
			setUrlParams(window.location.search);
      sessionStorage.setItem("urlParams", window.location.search);
      if (searchParams.get("token")){
        setShowShimmer(true)
        var jwtToken = searchParams.get("token")
        // console.log("token------------",searchParams.get("token"))
        const token = jwt_decode(jwtToken)
        // console.log("tokennnnnnnn", token)
        sessionStorage.setItem("headerToken", jwtToken);
        sessionStorage.setItem("application_form_no", token.application_form_number);
        sessionStorage.setItem("urlParams", urlParams);
        sessionStorage.setItem("mobile_number", token.sub)
        // console.log("mobile_number--------->", token.sub)
        // console.log(token.application_form_number);
        var payload = {
          mobile_number: token.sub,
          dsa_hash: searchParams.get("dsa_hash")
        };
        try {
          
          await initEsb(token.sub);
        } catch (error) {
            // console.log("ERROR: ", error);
            setShowShimmer(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
  
            navigate(`${route}`, {
              replace: true,
            });
          }
      };
		} else {
			setShowInvalidURLModal(true);
		}
   }, []);


  useEffect(() => {
    const updated = customerDetails;
    console.log(sessionStorage.getItem("dsa_hash"));
    updated.source = source;
    setCustomerDetails({
      ...updated,
    });
  }, []);

  useEffect(() => {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("inside useEffect");

      var url = `${route}`;
      // console.log(route);
      // console.log(sessionStorage.getItem("dsa_hash"));
      // console.log(route === `${source}/login`);
      if (route === `/${source}/login` && urlParams) {
        // console.log("jksfdjksfdjkbsdfjkbsdfjkbsd");
        url = `${route}${urlParams}`;
      }

      navigate(url, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    }
  }, [customerDetails]);

  const getOTP = async () => {
    const token = await executeRecaptcha();

    if (isValidNum) {
      if (!isOtpSent) {
        setShowShimmer(true);
      }
      var payload = {
        mobile_number: mobNum,
        mode: "LOGIN",
      };
      try {
        const formData = new FormData();
        formData.append("data", encryptedData(payload));
        const response = await sendRequest(
          "/" + source + SEND_OTP,
          formData, "POST",
          // token
        );
        // console.log("Send Response: ", response);
        const retryTimer = response.response.Data.retryTimer;
        const retryMin = Math.floor(retryTimer / 60);
        const retrySec = Math.ceil(retryTimer % 60);
        if (response.response.Success) {
          setShowShimmer(false);
          setIsOtpSent(true);
          setResendOtp(true);
          setMinutes(0);
          setSeconds(60);
          setConsentFlag(false);
        }
        else{
          if(response.response.Message.ERROR == "reCAPTCHA validation failed"){
            setShowShimmer(false);
            setShowInvalidCaptchaModal(true);
          }
        }
        if (response.response.ErrorType === "OTP_MAX_RETRY") {
          setShowMaxRetryModal(true);
          setShowShimmer(false);
          setIsOtpSent(true);
          setMinutes(retryMin);
          setSeconds(retrySec);
          setConsentFlag(false);
        }
      }
      catch (error) {
        console.error(`Unknown Error: Constants Not Retireved - ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        const url = `${route}`;
        navigate(url, {
          replace: true,
        });
      }
	  }
  };

  const resendOTP = async () => {
    const token = await executeRecaptcha();

    var payload = {
      mobile_number: mobNum,
      mode: "LOGIN",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      setIsOtpSent(false);
      const response = await sendRequest("/" + source + SEND_OTP, formData, "POST",token);
      // console.log("Resend Response: ", response);
      const retryTimer = response.response.Data.retryTimer;
      const retryMin = Math.floor(retryTimer / 60);
      const retrySec = Math.ceil(retryTimer % 60);
      if (response.response.Success) {
        setShowShimmer(false);
        setIsOtpSent(true);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(0);
        setSeconds(60);
        resetOTP();
        setConsentFlag(false);
      }
      else{
        if(response.response.Message.ERROR == "reCAPTCHA validation failed"){
          setShowShimmer(false);
          setShowInvalidCaptchaModal(true);
        }
      }
      if (response.response.ErrorType === "OTP_MAX_RETRY") {
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setIsOtpSent(true);
        SetEnableResendOtp(false);
        setMinutes(retryMin);
        setSeconds(retrySec);
        setConsentFlag(false);
      }
    } catch (error) {
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      const url = `${route}`;
      navigate(url, {
        replace: true,
      });
    }
  };

  const verifyOTP = async () => {
    if (isOtpValid) {
      var payload = {
        mobile_number: mobNum,
        otp: otp,
        mode: "LOGIN",
      };
      try {
        setShowShimmer(true);
        const formData = new FormData();
        formData.append("data", encryptedData(payload));
        const response = await sendRequest("/" + source + VERIFY_OTP, formData);
        if (response.response.ErrorType === "INVALID_OTP") {
          setShowShimmer(false);
          SetIsOtpWrong(true);
        }
        if (response.response.ErrorType === "OTP_EXPIRED") {
          setShowShimmer(false);
          setShowOtpExpiredModal(true);
        }
        if (response.response.ErrorType === "OTP_MAX_RETRY") {
          setShowShimmer(false);
          setShowVerifyMaxRetryModal(true);
        }    
        if (response.response.Success) {
          // console.log("RES_HEADERS:", response.response);
          sessionStorage.setItem("headerToken", response.headers.get('Token'))
          sessionStorage.setItem("locationErrorCount", 3);
          await initEsb(mobNum);
        }
      } catch (error) {
        console.error(`Unknown Error: Constants Not Retireved - ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });

        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const initEsb = async (mobNum) => {
    var payload = {
      mobile_number: mobNum,
      dsa_hash: searchParams.get("dsa_hash"),
      utm_params: {
        utm_source: searchParams.get("utm_source"),
        utm_medium: searchParams.get("utm_medium"),
        utm_campaign: searchParams.get("utm_campaign"),
        utm_term: searchParams.get("utm_term"),
        utm_content: searchParams.get("utm_content"),
      },
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + source + INIT_ESB,
        formData
      );

      if (response.response.Success) {
        sessionStorage.setItem("eplAuth", "authenticated");
        sessionStorage.setItem("redirectUrl", response.response.redirect_url);
        setCustomerDetails({
          ...customerDetails,
          application_form_number:
            response.response.Data.application_form_number,
          stage: response.response.STAGE,
        });
        const pathArray = location.pathname.split('/');
        const endpoint = pathArray[pathArray.length - 1];
        sessionStorage.setItem("URLEndpoint", endpoint);
        sessionStorage.setItem(
          "application_form_no",
          response.response.Data.application_form_number
        );
        sessionStorage.setItem("headerToken", response.headers.get("Token"));
        sessionStorage.setItem("dsa_hash", searchParams.get("dsa_hash"));
        sessionStorage.setItem("utm_source", searchParams.get("utm_source"));
        sessionStorage.setItem("utm_medium", searchParams.get("utm_medium"));
        sessionStorage.setItem("utm_campaign", searchParams.get("utm_campaign"));
        sessionStorage.setItem("utm_term", searchParams.get("utm_term"));
        sessionStorage.setItem("utm_content", searchParams.get("utm_content"));
        setShowShimmer(false);
        createLead(source, 95, response.response.Data.application_form_number)
      }
      else {
        if (response.response.Message === "Invalid DSA") {
          setShowInvalidHashModal(true);
          setShowShimmer(false);
        }
        else if (response.response.Message === "DSA is None") {
          setShowInvalidHashModal(true);
          setShowShimmer(false);
        }
        else {
          setShowNoOfferModal(true);
          setShowShimmer(false);
        }
      }
    } catch (error) {
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });

      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  const updateMobileNumber = async (e) => {
    if (e.target.value.length <= 10) {
      // // console.log(e.target.value);
      setMobNum(e.target.value);
      if (isValidMobileNumber(e.target.value)) {
        setCustomerDetails({
          ...customerDetails,
          mobile_number: e.target.value,
        });
        setMobileNumberError(false);
        setIsValidNum(true);
        setMobileNumberError(false);
        setMobileNumberErrorMessage("");
      } else {
        setMobileNumberError(true);
        setMobileNumberErrorMessage("Please enter valid mobile number");
        setIsValidNum(false);
      }
    } else {
    }
  };

  const handleEditClick = () => {
    setIsOtpSent(false);
  };

  /**
  * countdown timer used for resend functionality
  */
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.removeItem("application_form_no");
    sessionStorage.removeItem("eplAuth");
    sessionStorage.removeItem("headerToken");
  }, []);

  useEffect(() => {
    var inputBox = document.getElementById("MobileNumber");

    var invalidChars = ["-", "+", "e"];

    inputBox.addEventListener("keydown", function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  return (
		<>
			<AfterLoginLayoutWrapper width={"100%"}>
				<LoginWrapper className="first-child">
					<OtpExpiredModal
						isOpen={showOtpExpiredModal}
						onClose={() => {
							resendOTP();
							setShowOtpExpiredModal(false);
							resetOTP();
						}}
					/>
					<NoOfferFoundModal
						isOpen={showNoOfferModal}
						modalImage={LoanExpired}
						onClose={() => {
							setShowNoOfferModal(false);
							resetOTP();
							setMobNum("");
							setIsOtpSent(false);
						}}
					/>
					<InvalidHashModal
						isOpen={showInvalidHashModal}
						modalImage={LoanExpired}
						onClose={() => {
							setShowInvalidHashModal(false);
							resetOTP();
							setMobNum("");
							setIsOtpSent(false);
						}}
					/>
					<InvalidURLModal
						isOpen={showInvalidURLModal}
						modalImage={LoanExpired}
						onClose={() => {}}
					/>
					<ResendOtpModal
						mobileNumber={mobNum.slice(6, 10)}
						isOpen={resendOtp}
						onClose={() => {
							SetEnableResendOtp(false);
							setResendOtp(false);
							setSeconds(60);
							resetOTP();
						}}
					/>
					<IncorrectOtpModal
						isOpen={isOtpwrong}
						onClose={() => {
							SetIsOtpWrong(false);
							resetOTP();
						}}
					/>
					<MaxOtpRetryModal
						isOpen={showMaxRetryModal}
						onClose={() => {
							setShowMaxRetryModal(false);
							SetEnableResendOtp(false);
							setResendOtp(false);
							resetOTP();
						}}
					/>
          <MaxVerifyOtpRetryModal
						isOpen={showVerifyMaxRetryModal}
						onClose={() => {
							setShowVerifyMaxRetryModal(false);
							setIsOtpSent(false)
							setConsentFlag(true)
							setConsentCheckbox(false)
							setMobNum("")
						}}
					/>
					<InvalidCaptchaModal
						isOpen={showInvalidCaptchaModal}
						modalImage={LoanExpired}
						onClose={() => {
							setShowInvalidCaptchaModal(false);
              setConsentFlag(true);
							setIsValidNum(false);
							setConsentCheckbox(!consentCheckbox);
							resetOTP();
							setMobNum("");
							setIsOtpSent(false);
						}}
					/>
					<div id="login-form">
						<div>
							<div className="heading">
								<img
									style={{
										cursor: "pointer",
										paddingTop: "10px",
									}}
									src={BackButton}
									alt="BackButton.svg"
									onClick={() => {
										var route =
											getRouteFromLoanStageService({
												source: source,
												stage: "index",
											});
										// console.log("stage: ", customerDetails.stage);
										// console.log("route: ", route);
										if (urlParams) {
											// console.log(searchParams.get("dsa_hash"));
											// const url = `${route}?dsa_hash=${sessionStorage.get("dsa_hash")}`
											const url = `${route}${urlParams}`;
											navigate(url, {
												replace: true,
											});
										} else {
											const url = `${route}`;
											navigate(url, {
												replace: true,
											});
										}
									}}
								/>
								<Title
									text={`Let's get to know you`}
									visible={true}
									clickable={false}
								/>
								<div></div>
							</div>
							<div className="pageSubTitle">
								<SubTitle
									text={`We need a few details to get you started on your application`}
									visible={true}
									clickable={false}
								/>
							</div>
						</div>
						<div className="broadLine" />
						{showShimmer ? (
							<>
								<ShimmerPlaceholder
									height="3em"
									width="15em"
									marginTop="2em"
									visible={showShimmer}
								/>
								<ShimmerPlaceholder
									height="3em"
									width="22em"
									marginTop="1em"
									visible={showShimmer}
								/>
								<ShimmerPlaceholder
									height="2em"
									width="18em"
									marginTop="1em"
									visible={showShimmer}
								/>
							</>
						) : (
							<>
								<div className="heading2">Login/Signup</div>
								<div className="form-input">
									<FloatingInput
										label={"Mobile Number"}
										id="MobileNumber"
										type="Number"
										value={mobNum}
										disabled={isOtpSent}
										error={mobileNumberError}
										error_message={mobileNumberErrorMessage}
										on_change={updateMobileNumber}
										suffixIcon={
											isOtpSent ? (
												<div
													className="edit-button"
													onClick={handleEditClick}
												>
													<img
														src={EditIcon}
														alt="EditIcon.svg"
														height="20"
														width="20"
													/>
													<span
														style={{
															fontSize: "15px",
															marginLeft: "3px",
														}}
													>
														Edit
													</span>
												</div>
											) : null
										}
									/>
									{consentFlag ? (
										<CheckField
											id="basic-ckeckfield"
											checked={consentCheckbox}
											label="Mobile number provided is linked with my Aadhaar Number"
											style={{
												fontSize: "1.4rem",
												marginTop: "28px",
											}}
											onClick={updateConsentCheckbox}
										/>
									) : (
										<></>
									)}
								</div>
								<div className="display-message">
									{isOtpSent
										? "OTP has been sent on mobile number"
										: "You will receive OTP on mobile number"}
								</div>
							</>
						)}

						{showShimmer ? (
							<>
								<ShimmerPlaceholder
									height="3em"
									width="10em"
									marginTop="2em"
									visible={showShimmer}
								/>
								<ShimmerPlaceholder
									height="3em"
									width="20em"
									marginTop="1em"
									visible={showShimmer}
								/>
								<ShimmerPlaceholder
									height="2em"
									width="12em"
									marginTop="0.5em"
									visible={showShimmer}
								/>
								<ShimmerPlaceholder
									height="3em"
									width="9em"
									marginTop="1em"
									marginBottom="1em"
									visible={showShimmer}
								/>
							</>
						) : (
							<>
								{isOtpSent ? (
									<>
										<div className="heading2">
											Enter OTP
										</div>
										<div className="otp-box">
											<div>
												<OTPInput
													length={6}
													otpDigits={otpDigits}
													setOtpDigits={setOtpDigits}
												/>
											</div>
										</div>
										<div className="resnd-otp-row">
											<div className="resend-otp">
												{enableResendOtp ? (
													<></>
												) : (
													<>
														<img
															className="timer-img"
															src={timer}
														/>
													</>
												)}
												<button
													disabled={!enableResendOtp}
													style={{
														border: "None",
														backgroundColor:
															"transparent",
														color: enableResendOtp
															? "#3C94FC"
															: "grey",
														marginRight: "5px",
													}}
													onClick={async () => {
														await resendOTP();
														// console.log("resend OTP clicked");
													}}
												>
													Re-send OTP
												</button>
											</div>
											{enableResendOtp ? (
												<></>
											) : (
												<>
													<div>
														in{" "}
														{minutes < 10
															? `0${minutes}`
															: minutes}
														:
														{seconds < 10
															? `0${seconds}`
															: seconds}
														{/* in 00:
                            {seconds < 10 ? `0${seconds}` : seconds} */}
													</div>
												</>
											)}
										</div>
										<Button
											id="VerifyOTP"
											className="Btn VerifyOTP"
											disabled={!isOtpValid}
											mobile={isMobile}
											onClick={verifyOTP}
											text={"Verify"}
										/>
									</>
								) : (
									<>
										{showShimmer ? (
											<></>
										) : (
											<>
												<Button
													id="GetOTP"
													className="Btn GetOTP"
													// disabled={!isValidNum}
													disabled={
														!(
															isValidNum &&
															consentCheckbox
														)
													}
													mobile={isMobile}
													onClick={getOTP}
													text={"Get OTP"}
												/>
											</>
										)}
									</>
								)}
							</>
						)}
					</div>
					<div className="bottomDiv">
						<div className="features-box">
							<div className="features-box-heading">
								Key Features
							</div>
							<div className="features-box-content">
								&#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Low
								interest rates
							</div>
							<div className="features-box-content">
								&#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flexible
								EMI and Tenure
							</div>
							<div className="features-box-content">
								&#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Easy Loan
								servicing through Aditya Birla Capital Limited
								mobile app
							</div>
						</div>
						<div className="privacy-policy">
							<PrivacyPolicy />
						</div>
					</div>
				</LoginWrapper>
			</AfterLoginLayoutWrapper>
		</>
  );
};

export default Login;
